import { render } from "./CreateGroup.vue?vue&type=template&id=98a49350&ts=true"
import script from "./CreateGroup.vue?vue&type=script&lang=ts"
export * from "./CreateGroup.vue?vue&type=script&lang=ts"

import "./CreateGroup.vue?vue&type=style&index=0&id=98a49350&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__